import {} from "@mui/material";
import type React from "react";
import type { AdminContractDetailPageProps } from "../model";
import { ContractDetailInProgress } from "./in-progress";
import { ContractDetailPreview } from "./preview";

export const AdminContractDetailPageUi: React.FC<
  AdminContractDetailPageProps
> = (props) => {
  if (props.previewValues) {
    return <ContractDetailPreview {...props} />;
  }
  return <ContractDetailInProgress {...props} />;
};
